import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  MobileCustomPlansServiceNoSync, MobilePlanItem,
  CustomizableMobilePlan, CART_TYPES, ActionsAnalyticsService, PURCHASE_INTENT, UserAccountServiceNoSync, IUserAccount, UserPlansService, IUserPlan,
} from '@ztarmobile/zwp-service-backend';
import { AppState } from '../../../app.service';
import { MetaService } from '../../../../services/meta-service.service';
import { ContentfulService } from '../../../../services/contentful.service';
import { ModalHelper } from '../../../../services/modal-helper.service';
import { SHOP_ROUTE_URLS } from '../../../app.routes.names';
import { takeWhile } from 'rxjs/operators';
import Swiper, { Keyboard, Navigation, Pagination, SwiperOptions } from 'swiper';

@Component({
  selector: 'app-plan-details-list',
  templateUrl: './plan-details-list.component.html',
  styleUrls: ['./plan-details-list.component.scss']
})
export class PlanDetailsListComponent implements OnDestroy, OnInit {

  public planId: string;
  public selectedPlan: MobilePlanItem;
  public parentPlan: MobilePlanItem;
  public userCart: CustomizableMobilePlan;
  public userAccount: IUserAccount;
  public userPlan: IUserPlan;
  public questionId: string;
  public questionIdParam: string;
  public plansFaqs: any;
  public collapsed = false;
  public filteredPlans: Array<MobilePlanItem>;
  public innerWidth;
  public swiper: any;
  public config: SwiperOptions = {
    direction: 'horizontal',
    keyboard: false,
    mousewheel: false,
    scrollbar: false,
    centeredSlides: true,
    roundLengths: true,
    loopFillGroupWithBlank: true,
    slideToClickedSlide: true,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    slidesPerView: 'auto',
    initialSlide: 0,
    observer: true,
    effect: 'slide',
    pagination: {
      el: '.slider-pagination',
      renderBullet: (index, className) => `<li style="z-index: 10" class="slick-active ${className}"><button ></button></li>`,
      clickable: true
    },
    spaceBetween: -32
  };
  public suggestedPlanDesc;
  private alive = true;

  constructor(private route: ActivatedRoute, private mobilePlansService: MobileCustomPlansServiceNoSync, private router: Router,
    private modalHelper: ModalHelper,
    private analyticsService: ActionsAnalyticsService,
    private appState: AppState, private contentfulService: ContentfulService, private userAccountService: UserAccountServiceNoSync, private userPlansService: UserPlansService,
    private metaService: MetaService,
    private cdr: ChangeDetectorRef) {
    sessionStorage.removeItem('planID');
    this.mobilePlansService.currentPlan.pipe(takeWhile(() => this.alive)).subscribe((cart) => {
      this.userCart = cart;
    });
    this.userAccountService.selectedAccount.pipe(takeWhile(() => this.alive)).subscribe((account) => {
      this.userAccount = account;
    });
    this.innerWidth = window.screen.width;
    this.userPlansService.isSelectedPlanReady.pipe(takeWhile(() => this.alive)).subscribe((userPlanReady) => {
      if (userPlanReady) {
        this.userPlan = this.userPlansService.selectedUserPlan;
        if (!!this.userPlan) {
          const storedId = sessionStorage.getItem('plan_id');
          if (this.userPlan.id !== storedId) {
            this.userPlansService.getUserPlan(storedId).then((plan) => {
              this.userPlan = plan;
            });
          }
        }
      }
    });
  }
  ngOnInit(): void {
    this.planId = this.route.snapshot.paramMap.get('id');
    this.plansFaqs = this.contentfulService.getQuestionsByCategoryId('faqs', 'plans questions');
    this.metaService.createCanonicalUrl();
    if (!!this.planId) {
      this.mobilePlansService.isConfigurationReady.pipe(takeWhile(() => this.alive)).subscribe((isReady) => {
        if (!!isReady) {
          this.selectedPlan = this.mobilePlansService.allBasePlans.find((plan) => plan.id === this.planId.toUpperCase());
          this.parentPlan = this.mobilePlansService.allBasePlans.find((plan) => plan.id === this.selectedPlan.parentId);
          const allBasePlans = this.mobilePlansService.allBasePlans;
          if (!!this.selectedPlan && this.selectedPlan?.subscriptionCycles === 1) {
            this.suggestedPlanDesc = `Check out our <b>3-month</b> Intro Price offers!`;
            this.filteredPlans = allBasePlans.filter((plan) => !!plan.parentId && !!plan?.subscriptionCycles && plan?.subscriptionCycles === 3);
          } else if (!!this.selectedPlan && this.selectedPlan?.subscriptionCycles === 3) {
            this.suggestedPlanDesc = `Upgrade to our annual plan and lock in great intro price!`;
            this.filteredPlans = allBasePlans.filter((plan) => !!plan.parentId && !!plan?.subscriptionCycles && ((plan?.subscriptionCycles === 6 && plan?.details?.data === this.selectedPlan?.details?.data) || (plan?.subscriptionCycles === 12 && plan?.details?.data === this.selectedPlan?.details?.data)));
          } else if (!!this.selectedPlan && this.selectedPlan?.subscriptionCycles === 6) {
            this.suggestedPlanDesc = `Check out our <b>12-month</b> plan offers!`;
            this.filteredPlans = allBasePlans.filter((plan) => !!plan.parentId && !!plan?.subscriptionCycles && plan?.subscriptionCycles === 12);
          } else if (!!this.selectedPlan && this.selectedPlan?.subscriptionCycles === 12) {
            this.suggestedPlanDesc = `Check out our <b>12-month</b> plan offers!`;
            this.filteredPlans = allBasePlans.filter((plan) => !!plan.parentId && !!plan?.subscriptionCycles && plan?.subscriptionCycles === 12 && plan?.details?.data !== this.selectedPlan?.details?.data);
          } else {
            this.suggestedPlanDesc = `Check out our plans offers!`;
            this.filteredPlans = allBasePlans.filter((plan) => !!plan.parentId);
          }
          this.filteredPlans.sort((a, b) => a.details.data - b.details.data);
          this.cdr.detectChanges();
          this.createSwiper();
          this.analyticsService.trackProductDetails(this.selectedPlan);
          this.trackViewItemEvent();
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.alive = false;
    if (!!this.swiper) {
      this.swiper.destroy(true, true);
    }
  }
  public addPlanToCart(plan?): void {
    if (!!plan) {
      this.selectedPlan = plan;
    }
    sessionStorage.setItem('planID', JSON.stringify(this.selectedPlan.id));
    if ((!this.userCart.planDevice) || (!!this.userCart.planDevice && !this.userCart.planDevice.id)) {
      this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.CHECK_PHONE}`]);
    } else {
      this.addPlan(this.selectedPlan);
      this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.CART}`]);
    }
  }

  public toggleActive(targetId, answerId): void {
    if (this.questionId === targetId && !this.collapsed) {
      this.questionId = 'q0';
    } else {
      this.questionId = targetId;
      this.collapsed = false;
      this.callRichText(answerId);
    }
  }
  public showCountries(): void {
    this.modalHelper.showILDCountries();
  }
  private callRichText(id): void {
    this.contentfulService.getRichText('questions', id);
  }
  private checkCart(): boolean {
    if (!!this.userCart && !!this.userCart.cartType && this.userCart.cartType !== CART_TYPES.NEW_PLAN) {
      this.modalHelper.showConfirmMessageModal('Clear Cart', 'Adding new plan will remove other items in your cart. Do you want to proceed?', 'Yes', 'No', 'clean-cart-modal')
        .afterClosed().subscribe((result) => {
          if (!!result) {
            this.clearCart();
            return true;
          }
        }, (error) => {
          console.error('error', error);
        });
      return false;
    } else {
      return true;
    }
  }
  private clearCart(): void {
    const removedItems = [];
    if (this.userCart.cartType !== CART_TYPES.PLAN_ITEMS) {
      removedItems.push(this.userCart.basePlan);
    } else {
      if (this.userCart.simsQuantity > 0) {
        removedItems.push({ id: 'SIMFRP4GLTE', quantity: this.userCart.simsQuantity, price: 10, type: 'plan-item', title: 'SIM CARD' });
      }
      if (!!this.userCart.addOns) {
        removedItems.push(this.userCart.addOns);
      }
    }
    this.analyticsService.trackRermoveFromCartGA4(removedItems);
    this.mobilePlansService.setSimPurchaseQuantity(0);
    this.mobilePlansService.setAddonsList(null, this.userCart);
    this.mobilePlansService.setActivePlanId(null);
    this.appState.clearSessionStorage();
  }
  private addPlan(plan: any): void {
    if (this.checkCart()) {
      sessionStorage.removeItem('useFromBalance');
      sessionStorage.removeItem('voucherUsed');
      const price = plan.subscriptionCycles * plan.price;
      this.analyticsService.trackAddToCartGA4(PURCHASE_INTENT.NEW, [plan], price);
      this.mobilePlansService.setBasePlan(plan);
      this.mobilePlansService.setCartType(CART_TYPES.NEW_PLAN);
      this.mobilePlansService.setAutoRenewPlan(true);
    }
  }
  private trackViewItemEvent(): void {
    let data = {
      event: 'view_item',
      ecommerce: {
        currency: "USD",
        item_id: this.selectedPlan.id,
        item_name: this.selectedPlan.title,
        affiliation: 'FreeUp Mobile',
        item_category: 'Plan',
        price: this.selectedPlan.price * this.selectedPlan.subscriptionCycles,
        quantity: 1
      }
    }
    this.analyticsService.trackGAEvent(data);

  }
  private createSwiper(): void {
    this.swiper = new Swiper('.main-plans', {
      hashNavigation: true,
      modules: [Navigation, Pagination, Keyboard],
      ...this.config,
    });
    this.cdr.detectChanges();
  }
  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.innerWidth = document.documentElement.clientWidth;
  }
}

